import React from "react";
import PropTypes from "prop-types";
import { TButtonProps } from "types/Components/Common/Button";

const BorderlessButton = ({
  type = "button",
  id = "",
  onClick,
  disabled = false,
  disabledClassName = "!tw-text-primary-disabled",
  className="tw-text-primary",
  children,
  color,
}: TButtonProps) => {
  return (
    <div>
      <button
        type={type}
        className={`tw-bg-transparent tw-border hover:!tw-text-primary-hover tw-font-normal !tw-border-transparent ${disabled && disabledClassName} ${className} 
          focus:tw-outline-none tw-p-2 tw-py-1 tw-font-medium tw-leading-5 tw-min-h-[36px] tw-m-0 tw-min-w-[92px]
          tw-cursor-pointer tw-inline-block tw-font-noto-sans tw-text-sm`}
        id={id}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
};

export default BorderlessButton;